<template>
  <div class="header shadow">
    <div class="box"></div>
    <div class="nlb-logo">
      <img src="../../assets/nlb-logo.png" alt="" width="30" height="24" />
    </div>
    <div class="breadcrumb">
      <nav aria-label="breadcrumb ">
        <ol class="breadcrumb arr-right">
          <li class="breadcrumb-item">
            <router-link
              :to="{ name: 'content' }"
              class="text-primary text-decoration-none"
            >
              SDPS
            </router-link>
          </li>
          <li
            v-for="(breadcrumb, index) in breadcrumbList"
            :key="index"
            class="breadcrumb-item"
          >
            <strong
              v-if="index === breadcrumbList['length'] - 1"
              class="text-primary text-decoration-none font-weight-bold"
            >
              {{ breadcrumb["name"] }}
            </strong>
            <a v-else class="text-primary text-decoration-none">
              {{ breadcrumb["name"] }}
            </a>
          </li>
        </ol>
        <h2>{{ $route.meta.routedLink }}</h2>
      </nav>
    </div>
    <div class="logout">
      <i class="bi bi-person"></i>
      <span>Hi, {{ authenticationStore.profile_name }}</span>
      <span
        v-if="
          authenticationStore.role == 'Super Admin' ||
          authenticationStore.role == 'Administrator'
        "
      >
        ({{ authenticationStore.role }})</span
      >
      <span v-else>
        ({{ authenticationStore.department }},
        {{ authenticationStore.role }})</span
      >
      <i class="bi bi-gear"></i><span>Isolated Zone</span>
      <i
        class="bi bi-box-arrow-right"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#logoutModal"
      ></i
      ><span type="button" data-bs-toggle="modal" data-bs-target="#logoutModal"
        >Logout</span
      >
    </div>
  </div>
  <!-- logout Modal -->
  <div
    class="modal fade"
    id="logoutModal"
    tabindex="-1"
    aria-labelledby="logoutModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="logoutModalLabel">Logout Confirmation</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">Are you sure you want to logout?</div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="logout"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { useAuthenticationStore } from "@/stores/authentication";
import { computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const authenticationStore = useAuthenticationStore();

const breadcrumbList: object = computed(
  () => router.currentRoute.value.meta.breadcrumb
);
const logout = () => {
  authenticationStore.removeUser();
};
</script>

<style scoped lang="scss">
.header {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.header > div {
  display: table-cell;
}
.box {
  height: 50px;
  width: 65px;
}
.nlb-logo {
  padding: 15px;
  width: 70px;
}
.breadcrumb {
  margin-right: 15px;
}
.arr-right .breadcrumb-item + .breadcrumb-item::before {
  content: "›";
  vertical-align: left;
  color: #0065cc;
  font-size: 35px;
  line-height: 8px;
}
.logout {
  text-align: end;
  padding-right: 16px;
}
.bi {
  font-size: 20px;
  &.bi-person {
    padding-left: 4px;
    padding-right: 4px;
  }
  &.bi-box-arrow-right {
    padding-left: 4px;
    padding-right: 4px;
  }
  &.bi-gear {
    padding-left: 4px;
    padding-right: 4px;
  }
}
</style>
